import { LOGIN_STARTED } from "../../actions/types/signin.types";
import {
    FETCH_DIRECTORS_N_SHAREHOLDERS_STARTED,
    FETCH_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED,
    FETCH_DIRECTORS_N_SHAREHOLDERS_FAILED,
    FETCH_DIRECTORS_CONSENT_STARTED,
    FETCH_DIRECTORS_CONSENT_SUCCEEDED,
    FETCH_DIRECTORS_CONSENT_FAILED,
    RETRIEVE_OWNER_CONSENT_STARTED,
    RETRIEVE_OWNER_CONSENT_SUCCEEDED,
    RETRIEVE_OWNER_CONSENT_FAILED,
    UPDATE_DIRECTORS_N_SHAREHOLDERS_STARTED,
    UPDATE_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED,
    UPDATE_DIRECTORS_N_SHAREHOLDERS_FAILED,
} from "./types";

const initialState = {
    fetchingDirectorsNShareHolder: "idle",
    fetchingDirectorConsent: "idle",
    retrievingOwnersConsent: "idle",
    directorsNShareHolders: {
        directors: [],
        shareholders: [],
        proprietors: [],
    },
    directorsConsent: [],
    error: null,
    ownerConsent: {},
    update: { loading: false, data: null, error: null },
};

const bizOnboardingReducer = (state = initialState, action) => {
    switch (action?.type) {
        case FETCH_DIRECTORS_N_SHAREHOLDERS_STARTED:
            return {
                ...state,
                fetchingDirectorsNShareHolder: "loading",
            };
        case FETCH_DIRECTORS_N_SHAREHOLDERS_FAILED:
            return {
                ...state,
                fetchingDirectorsNShareHolder: "failed",
                error: action.payload,
            };

        case FETCH_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED:
            return {
                ...state,
                fetchingDirectorsNShareHolder: "loaded",
                directorsNShareHolders: { ...action.payload.data },
            };

        case FETCH_DIRECTORS_CONSENT_STARTED:
            return {
                ...state,
                fetchingDirectorConsent: "loading",
            };

        case FETCH_DIRECTORS_CONSENT_FAILED:
            return {
                ...state,
                fetchingDirectorConsent: "failed",
                error: action.payload,
            };

        case FETCH_DIRECTORS_CONSENT_SUCCEEDED:
            return {
                ...state,
                fetchingDirectorConsent: "loaded",
                directorsConsent: [...action.payload.data],
            };

        case RETRIEVE_OWNER_CONSENT_STARTED:
            return {
                ...state,
                retrievingOwnersConsent: "loading",
            };

        case RETRIEVE_OWNER_CONSENT_FAILED:
            return {
                ...state,
                retrievingOwnersConsent: "failed",
                error: action.payload,
            };

        case RETRIEVE_OWNER_CONSENT_SUCCEEDED:
            return {
                ...state,
                retrievingOwnersConsent: "success",
                ownerConsent: { ...action.payload.data },
            };

        case UPDATE_DIRECTORS_N_SHAREHOLDERS_STARTED:
            return {
                ...state,
                update: {
                    ...state.update,
                    loading: true,
                    error: {
                        ...state.update.error,
                        [action.payload.field]: null,
                    }, // Clear any previous errors
                },
            };
        case UPDATE_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED:
            return {
                ...state,
                update: {
                    ...state.update,
                    loading: false,
                    data: action.payload.data, // Store the response data
                    error: {
                        ...state.update.error,
                        [action.payload.field]: null,
                    }, // Clear any error since the update succeeded
                },
            };
        case UPDATE_DIRECTORS_N_SHAREHOLDERS_FAILED:
            return {
                ...state,
                update: {
                    ...state.update,
                    loading: false,
                    error: {
                        ...state.update.error,
                        [action.payload.field]: action.payload.error,
                    },
                },
            };

        case LOGIN_STARTED:
            return {
                ...state,
                retrievingOwnersConsent: "idle",
                ownerConsent: {},
            };

        default:
            return state;
    }
};

export default bizOnboardingReducer;
